module.exports = __webpack_public_path__ + "static/img/app-store-btn.e21655d.png";